<template>
    <section class="hero is-fullheight">
        <div id="context_bar"></div>
        <titlePage>
            <template slot="titleBody">
                <h1 class="page-title title is-size-1">{{ $t('modules.auth.profile.title') }}</h1>
            </template>
        </titlePage>

        <div id="index_positions_content" class="hero flex" v-if="uSettings.settings">
            <div class="hero-body flex_content">
                <div class="container">

                    <div class="settings_form">
                        <div class="setting_section">
                            <h3>{{ $t('modules.auth.profile.settingsTitle') }}</h3>

                            <div class="columns">
                                <div class="column">
                                    <h4>{{ $t('modules.auth.profile.settingsManageSubtitle') }}</h4>

                                    <div class="notification is-inverse">
                                        {{ $t('modules.auth.profile.settingsManageNotice1') }}
                                        <br><br>
                                        <a target="_blank" :href="accountLink" class="button is-info is-outlined ">{{ $t('modules.auth.profile.settingsManageButton') }}</a>
                                    </div>

                                </div>
                            </div>


                        </div>

                        <div class="setting_section">
                            <h3>{{ $t('modules.auth.profile.notifsTitle') }}</h3>
                            <SwitchInput switchId="evaluation_notif"
                                :switchLabel="$t('modules.auth.profile.notifsRadioLabel')"
                                :value="valToBool(this.uSettings.settings.customisation.evaluation_notif)"
                                @change="handleSwitch" />
                        </div>

                        <button type="button" class="button is-outlined is-info" @click="saveSettings" >{{ $t('modules.auth.profile.saveButton') }}</button>

                    </div>
                </div>

                <transition name="notif-slide-up">
                    <alert class="login_notif" v-if="showSuccessNotif" context="success" @close="showSuccessNotif=false">
                        {{ $t('modules.auth.profile.notifSuccess') }}
                    </alert>
                </transition>

            </div>
        </div>
    </section>
</template>

<script>
import TitlePage from "@/components/layouts/titlePage"
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {

    name: 'Profile',
    components: {
        TitlePage
    },
    data(){
        return {
            emailSubject: '',
            emailContent: '',
            evaluation_notif: false,
            logo_email_enabled: false,
            logo_report_enabled: false,
            email_custom_enabled: false,
            CanAccess: userCanAccess,
            uAccess: JSON.parse(localStorage.getItem('account')),
            showSuccessNotif: false
        }
    },
    mounted(){
        this.$store.dispatch("UserStore/getSettings").then( (data) => {
            this.evaluation_notif = this.uSettings.settings.customisation.evaluation_notif == '1' ? true : false
        })
    },
    computed: {
        currentUser(){
            return JSON.parse(localStorage.getItem('account')).user
        },
        uSettings(){
            return this.$store.state.UserStore.userSettings
        },
        accountLink(){
            return `${process.env.VUE_APP_AXIOS_BASE_URL}user_account/login/new?language=${this.$i18n.locale}&account_token=${this.uSettings.account_token}`
        }
    },
    methods: {
        valToBool(val){
            return (val == "1" || val == true)
        },
        handleSwitch(id, value){
            this.evaluation_notif = value

        },
        saveSettings(){
            const settings = {
                sharp_settings: {
                    customisation: {
                        evaluation_notif: (this.valToBool(this.evaluation_notif) ? "1": "0"),
                    }
                }
            }
            this.$store.dispatch('UserStore/updateProfile', settings).then( (resp) => {
                this.showSuccessNotif = true
            })
        },
        updateFormData(){

        }
    }
}

</script>

<style lang="scss">
.setting_section{
    padding-bottom: 30px;
    h3{
        font-size: 1.75rem;
        margin: 18px 0;
        border-bottom: 1px solid $grey-lighter;

    }
    h4{
        font-weight: 600;
        color: $info;
        font-size: 1.25rem;
        margin: 12px 0;
    }
    .input, textarea, .notification{
        border-radius: 6px;
    }
    .field{
        margin-bottom: 30px!important;
    }
    .access_list{
        li{
            display: flex;
            align-items: center;
            .boolean_icon{
                margin-right: 8px;
            }
            span{
                font-size: 1.15rem;
            }
        }
    }
}
</style>
